import {
  FieldTypes,
  ReferenceCreatedByFields,
  SelectOptionFields,
  systemDateField,
  timeSlotPicker,
} from 'drapcode-constant';
import { processSteps } from '../collectionForm/utils';
import {
  getCollectionFields,
  getCollectionOptionsForSelect,
  getExternalAPIOptionsForSelect,
  getInstalledPlugins,
} from '../pluginComponentApi';
import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { durationOptions } from './consts';
import { filterFieldTraitOptions } from '../dataGroup/traitsApi';

const getFieldOptions = (collection) => {
  let options = [];
  if (collection && collection.fields) {
    const innerFields = collection.fields.filter((field) =>
      SelectOptionFields.includes(field.type),
    );
    options = innerFields.map((field) => {
      return { value: field.fieldName, name: field.fieldTitle.en };
    });
  }
  return options;
};

export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, collections, bindCollectionOptions, token, externalApis, version } = opt;
  let externalAPIList = externalApis.filter(
    (externalAPI) =>
      externalAPI.responseDataMapping &&
      externalAPI.responseDataMapping.selectedCollectionName !== '',
  );

  let { collection: pageCollection, session, sessionTenant } = bindCollectionOptions;

  let innerFieldOptions = [];
  if (pageCollection) {
    const { collectionId } = pageCollection;
    pageCollection = collections.find((col) => col.collectionName === collectionId);
    innerFieldOptions = getFieldOptions(pageCollection);
  }

  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=data-group-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  if (collections) {
    traitManager.addType('data-calendar-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div id="URL" class="settings--progress">
      ${
        collections || pageCollection
          ? `
          <div class="gjs-container">
            <div class="gjs-row mx-auto mb-2">
              <div class="badge badge-default cms--progress--step-1">
                <i class="wb webconnect"></i>
                <span class="step--desc">Step 1: Select Get Content From</span>
              </div>
            </div>
            <div class="gjs-row">
            <div class="gjs-label-wrp d-none">
            <div class="gjs-label" title="Get Content">Get Content</div>
          </div>
            <div id="select-getContentFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getContentFrom">
              <div class="gjs-field">
                <select class="select-getContentFrom form-control form-control-sm options-light">
                  <option value="">- Get Content -</option>
                  ${
                    collections
                      ? `
                      <option value="collections">Get Data From Collection</option>
                            `
                      : ''
                  }
                </select>
                </div>
              </div>
            </div>
          </div>
          `
          : ''
      }
    <div class="gjs-container cms-data-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select Collection / Field</span>
        </div>
        <div class="cms-create-collection-container mb-1" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
        </div>
        <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
          <div id="select-field-div" style="display: none" class="gjs-field">
            <select class="selectField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-external-api-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select External API</span>
        </div>
        <div class="create-external-api-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}externalapi/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create ExternalAPI
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-external-api-label" title="External API">External API</div>
        </div>
        <div id="select-external-api-div" class="gjs-field-wrp gjs-field-wrp--select-external-api">
          <div id="select-external-api-field-div" style="display: none" class="gjs-field">
            <select class="selectExternalApiField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-filter-container pb-0" style="display: none">
      <div class="gjs-row mx-auto pb-0">
        <div class="badge badge-default cms--progress--step-3">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 3: Select Filter (Optional)</span>
        </div>
      </div>
    </div>
     <div class="form-group filter-div" style="display: none">
        <select class="filter-select form-control form-control-sm options-light">
        </select>
     </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectExternalApiField = el.querySelector('.selectExternalApiField');
        const selectGetContentFrom = el.querySelector('.select-getContentFrom');
        const cmsFilterContainer = el.querySelector('.cms-filter-container');
        const cmsExternalAPIContainer = el.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = el.querySelector('.create-external-api-container');

        selectGetContentFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          let optionHtml = `<option value="">None</option>`;
          selectFieldDiv.style.display = 'block';

          if (selectGetContentFrom.value === 'externalApiResponse') {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'block';
            cmsExternalAPIContainer.style.display = 'block';
          } else {
            cmsCreateCollectionContainer.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }

          if (['collections', 'browserSession'].includes(selectGetContentFrom.value)) {
            optionHtml = getCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          } else if (selectGetContentFrom.value === 'innerFields') {
            optionHtml = `<option value="" selected>- Select Field -</option>`;
            optionHtml += `${innerFieldOptions
              .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
              .join('')}`;
          } else {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            selectFieldDiv.style.display = 'none';
            cmsFilterContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }
          selectField.innerHTML = optionHtml;
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectField');
        const filterDiv = elInput.querySelector('.filter-div');
        const filterSelect = elInput.querySelector('.filter-select');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsFilterContainer = document.querySelector('.cms-filter-container');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          if (selectGetContentFrom.value === 'innerFields') {
            cmsDataLabel.innerHTML = 'Collection Field';
            component.set('finderUuid', '');
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionName', '');
          } else {
            cmsDataLabel.innerHTML = 'Collection';
          }
        }

        let selectedCollection;
        let collectionName;
        if (selectGetContentFrom.value && select.value) {
          if (selectGetContentFrom.value === 'innerFields') {
            filterDiv.style.display = 'none';
            filterSelect.innerHTML = '';
            const selectedRefField = pageCollection.fields.find(
              (field) => field.fieldName === select.value,
            );
            const { refCollection, fieldName } = selectedRefField;
            collectionName = refCollection ? refCollection.collectionName : '';
            component.set('fieldName', fieldName || '');
            component.set('finderUuid', '');
            component.removeTrait('finderUuid');
            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (sessionDataPathTrait) {
              component.removeTrait('sessionDataPath');
            }
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
          } else if (selectGetContentFrom.value === 'collections') {
            component.set('fieldName', '');
            collectionName = select.value;
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
            const finderOptions = selectedCollection.finders.map((finder) => {
              return { value: finder.uuid, name: finder.name };
            });
            const findAllFinder = selectedCollection.finders.find(
              (finder) => finder.name === 'Find All' || finder.name === 'All Items',
            ).uuid;
            const filterTrait = component.getTrait('finderUuid');
            if (collectionName && findAllFinder) {
              component.set('finderUuid', findAllFinder);
            } else {
              component.set('finderUuid', '');
            }

            if (!filterTrait) {
              const traitOpts = {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              };
              component.addTrait(traitOpts, { at: component.getTraitIndex('collectionName') + 1 });
            } else {
              filterTrait.set('options', finderOptions);
            }
          } else if (selectGetContentFrom.value === 'browserSession') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionFrom', 'browserSession');
            collectionName = select.value;
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

            const filterTrait = component.getTrait('finderUuid');
            if (filterTrait) {
              component.removeTrait('finderUuid');
            }

            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (!sessionDataPathTrait) {
              component.addTrait(
                {
                  type: 'text',
                  label: 'Data Path',
                  name: 'sessionDataPath',
                  placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
                  changeProp: 1,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            }
          }

          const finderUuid = component.get('finderUuid');
          if (finderUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else {
            cmsFilterContainer.style.display = 'none';
          }

          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else if (
          selectGetContentFrom.value &&
          selectGetContentFrom.value === 'externalApiResponse'
        ) {
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', 'externalAPIResponse');
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          selectExternalApiFieldDiv.style.display = 'block';
          const selectedExternalAPI = selectExternalApiField.value
            ? externalAPIList.find(
                (externalAPI) => externalAPI.uuid === selectExternalApiField.value,
              )
            : '';
          const externalAPIResponseCollection = selectedExternalAPI
            ? selectedExternalAPI.responseDataMapping.selectedCollectionName
            : '';
          collectionName = externalAPIResponseCollection ? externalAPIResponseCollection : '';
          selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

          if (selectedExternalAPI) {
            selectedCollection.responseDataMapping =
              selectedExternalAPI.responseDataMapping.selectedMapping;
            selectedCollection.bodyDataFrom = selectedExternalAPI.bodyDataFrom;
            selectedCollection.sendFormData = selectedExternalAPI.sendFormData
              ? selectedExternalAPI.sendFormData
              : false;
            selectedCollection.externalApiId = selectedExternalAPI.uuid;
            let externalAPIData = {
              externalApiId: selectedExternalAPI.uuid,
              responseDataMapping: selectedExternalAPI.responseDataMapping.selectedMapping,
              bodyDataFrom: selectedExternalAPI.bodyDataFrom,
              sendFormData: selectedExternalAPI.sendFormData
                ? selectedExternalAPI.sendFormData
                : false,
            };
            component.set('externalApiData', externalAPIData);
          } else {
            if (selectedCollection) {
              selectedCollection.externalApiId = '';
            }
          }

          const responseDataMappingFields = [];
          if (
            selectedExternalAPI.responseDataMapping &&
            selectedExternalAPI.responseDataMapping.selectedMapping
          ) {
            component.set(
              'externalAPIResponseDataMapping',
              selectedExternalAPI.responseDataMapping.selectedMapping,
            );
            selectedCollection.fields.forEach((element) => {
              if (hiddenFormField.includes(element.fieldName)) {
                responseDataMappingFields.push(element);
              }
              if (
                selectedExternalAPI.responseDataMapping.selectedMapping[element.fieldName] &&
                !element.fieldName.startsWith('_')
              ) {
                responseDataMappingFields.push(element);
              }
            });
          }

          if (responseDataMappingFields && selectedCollection) {
            selectedCollection.fields = responseDataMappingFields;
            component.set('externalAPIResponseDataMappingFields', responseDataMappingFields);
          }
          cmsFilterContainer.style.display = 'none';
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else {
          cmsDataLabel.innerHTML = '';
          component.set('collectionName', '');
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', '');
          component.set('externalAPIResponseDataMapping', '');
          component.set('externalApiData', '');
          component.set('externalAPIResponseDataMappingFields', '');

          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (!select.value && selectGetContentFrom.value) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            cmsFilterContainer.style.display = 'none';
          }
        }
      },
      async onUpdate({ elInput, component }) {
        const componentAttrs = component.getAttributes();
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');

        const collectionName = component.get('collectionName');
        const fieldName = component.get('fieldName');
        const finderUuid = component.get('finderUuid');
        let selectedCollection = component.get('selectedCollectionData');
        const collectionFrom = component.get('collectionFrom');
        let selectedExternalApiData = component.get('externalApiData');

        let eventTitle = component.get('data-event-title');
        if (!eventTitle) {
          eventTitle = componentAttrs['data-event-title'];
        }
        let eventDuration = component.get('data-event-duration');
        if (!eventDuration) {
          eventDuration = componentAttrs['data-event-duration'];
        }
        let eventStartTime = component.get('data-event-starttime');
        if (!eventStartTime) {
          eventStartTime = componentAttrs['data-event-starttime'];
        }
        let eventEndTime = component.get('data-event-endtime');
        if (!eventEndTime) {
          eventEndTime = componentAttrs['data-event-endtime'];
        }
        let eventDurationTime = component.get('data-event-duration');
        if (!eventDurationTime) {
          eventDurationTime = componentAttrs['data-event-duration'];
        }
        let eventUrl = component.get('data-event-url');
        if (!eventUrl) {
          eventUrl = componentAttrs['data-event-url'];
        }
        let eventDate = component.get('data-event-date');
        if (!eventDate) {
          eventDate = componentAttrs['data-event-date'];
        }
        let eventTextColor = component.get('data-event-textcolor');
        if (!eventTextColor) {
          eventTextColor = componentAttrs['data-event-text-color'];
        }
        let eventBgColor = component.get('data-event-bg-color');
        if (!eventBgColor) {
          eventBgColor = componentAttrs['data-event-bg-color'];
        }
        let eventBorderColor = component.get('data-event-border-color');
        if (!eventBorderColor) {
          eventBorderColor = componentAttrs['data-event-border-color'];
        }
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const cmsFilterContainer = elInput.querySelector('.cms-filter-container');

        const cmsExternalAPIContainer = elInput.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = elInput.querySelector(
          '.create-external-api-container',
        );
        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (collectionName) {
          const response = await getCollectionFields(collectionName, collections);
          selectedCollection = response;
        }
        if (selectedCollection) {
          if (selectedExternalApiData) {
            if (
              !selectedCollection['externalApiId'] &&
              selectedExternalApiData.hasOwnProperty('externalApiId')
            ) {
              selectedCollection.externalApiId = selectedExternalApiData.externalApiId;
            }
            if (
              !selectedCollection['responseDataMapping'] &&
              selectedExternalApiData.hasOwnProperty('responseDataMapping')
            ) {
              selectedCollection.responseDataMapping = selectedExternalApiData.responseDataMapping;
            }
            if (
              !selectedCollection['bodyDataFrom'] &&
              selectedExternalApiData.hasOwnProperty('bodyDataFrom')
            ) {
              selectedCollection.bodyDataFrom = selectedExternalApiData.bodyDataFrom;
            }
            if (
              !selectedCollection['sendFormData'] &&
              selectedExternalApiData.hasOwnProperty('sendFormData')
            ) {
              selectedCollection.sendFormData = selectedExternalApiData.sendFormData;
            }
          }
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';

          if (selectedCollection) {
            const finderOptions = [{ value: '', name: '- Select Filter -', disabled: true }];
            const fieldDateTraitsOptions = [{ id: '', name: '- Select Field -', disabled: true }];
            const fieldTextTraitsOptions = [{ id: '', name: '- Select Field -', disabled: true }];
            const fieldUrlTraitsOptions = [{ id: '', name: '- Select Field -', disabled: true }];
            const fieldTextColorTraitsOptions = [
              { id: '', name: '- Select Field -', disabled: true },
            ];

            const fieldDurationTraitsOptions = [];
            selectedCollection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            const fieldDateOptions = await filterFieldTraitOptions(selectedCollection, [
              FieldTypes.date.id,
              ...timeSlotPicker,
              ...systemDateField,
              FieldTypes.text.id,
            ]);
            fieldDateTraitsOptions.push(...fieldDateOptions);
            const fieldTextOptions = await filterFieldTraitOptions(selectedCollection, [
              FieldTypes.text.id,
            ]);
            fieldTextTraitsOptions.push(...fieldTextOptions);
            const fieldUrlOptions = await filterFieldTraitOptions(selectedCollection, [
              FieldTypes.url.id,
            ]);
            fieldUrlTraitsOptions.push(...fieldUrlOptions);
            fieldDurationTraitsOptions.push(...durationOptions);
            const fieldTextColorOptions = await filterFieldTraitOptions(selectedCollection, [
              FieldTypes.text.id,
              FieldTypes.color.id,
            ]);
            fieldTextColorTraitsOptions.push(...fieldTextColorOptions);
            const eventTitleTrait = component.getTrait('data-event-title');
            if (!eventTitleTrait) {
              component.addTrait({
                name: 'data-event-title',
                label: 'Event Title',
                title: `title`,
                options: fieldTextTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventTitle &&
                eventTitle.includes('"') &&
                'functionType' in JSON.parse(eventTitle)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventTitleTraitSelect = eventTitleTrait ? eventTitleTrait.el : '';
                eventTitleTraitSelect.value = eventTitle;
              } else {
                eventTitleTrait.set('options', fieldTextTraitsOptions);
              }
            }
            const eventDateTrait = component.getTrait('data-event-date');
            if (!eventDateTrait) {
              component.addTrait({
                name: 'data-event-date',
                label: 'Event Date (Optional)',
                title: `eventdate`,
                options: fieldDateTraitsOptions,
                type: 'select',
              });
            } else {
              if (eventDate && eventDate.includes('"') && 'functionType' in JSON.parse(eventDate)) {
                // To Handle preselect trait option when JSON string in option value
                const eventDateTraitSelect = eventDateTrait ? eventDateTrait.el : '';
                eventDateTraitSelect.value = eventDate;
              } else {
                eventDateTrait.set('options', fieldDateTraitsOptions);
              }
            }
            const eventStartTimeTrait = component.getTrait('data-event-starttime');
            if (!eventStartTimeTrait) {
              component.addTrait({
                name: 'data-event-starttime',
                label: 'Event Start Time',
                title: `starttime`,
                options: fieldDateTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventStartTime &&
                eventStartTime.includes('"') &&
                'functionType' in JSON.parse(eventStartTime)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventStartTimeTraitSelect = eventStartTimeTrait ? eventStartTimeTrait.el : '';
                eventStartTimeTraitSelect.value = eventStartTime;
              } else {
                eventStartTimeTrait.set('options', fieldDateTraitsOptions);
              }
            }
            const eventEndTimeTrait = component.getTrait('data-event-endtime');
            if (!eventEndTimeTrait) {
              component.addTrait({
                name: 'data-event-endtime',
                label: 'Event End Time',
                title: `endtime`,
                options: fieldDateTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventEndTime &&
                eventEndTime.includes('"') &&
                'functionType' in JSON.parse(eventEndTime)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventEndTimeTraitSelect = eventEndTimeTrait ? eventEndTimeTrait.el : '';
                eventEndTimeTraitSelect.value = eventEndTime;
              } else {
                eventEndTimeTrait.set('options', fieldDateTraitsOptions);
              }
            }
            const eventDurationTrait = component.getTrait('data-event-duration');
            if (!eventDurationTrait) {
              component.addTrait({
                name: 'data-event-duration',
                label: 'Event Duration (in Mins.)',
                title: `duration`,
                options: fieldDurationTraitsOptions,
                type: 'select',
              });
            } else {
              eventDurationTrait.set('options', fieldDurationTraitsOptions);
            }

            const eventUrlTrait = component.getTrait('data-event-url');
            if (!eventUrlTrait) {
              component.addTrait({
                name: 'data-event-url',
                label: 'Event URL',
                title: `url`,
                options: fieldUrlTraitsOptions,
                type: 'select',
              });
            } else {
              if (eventUrl && eventUrl.includes('"') && 'functionType' in JSON.parse(eventUrl)) {
                // To Handle preselect trait option when JSON string in option value
                const eventUrlTraitSelect = eventUrlTrait ? eventUrlTrait.el : '';
                eventUrlTraitSelect.value = eventUrl;
              } else {
                eventUrlTrait.set('options', fieldUrlTraitsOptions);
              }
            }
            const eventTextColorTrait = component.getTrait('data-event-text-color');
            if (!eventTextColorTrait) {
              component.addTrait({
                name: 'data-event-text-color',
                label: 'Event Text Color',
                title: `Text Color`,
                options: fieldTextColorTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventTextColor &&
                eventTextColor.includes('"') &&
                'functionType' in JSON.parse(eventTextColor)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventTextColorTraitSelect = eventTextColorTrait ? eventTextColorTrait.el : '';
                eventTextColorTraitSelect.value = eventTextColor;
              } else {
                eventTextColorTrait.set('options', fieldTextColorTraitsOptions);
              }
            }
            const eventBgColorTrait = component.getTrait('data-event-bg-color');
            if (!eventBgColorTrait) {
              component.addTrait({
                name: 'data-event-bg-color',
                label: 'Event Bg Color',
                title: `Background Color`,
                options: fieldTextColorTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventBgColor &&
                eventBgColor.includes('"') &&
                'functionType' in JSON.parse(eventBgColor)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventBgColorTraitSelect = eventBgColorTrait ? eventBgColorTrait.el : '';
                eventBgColorTraitSelect.value = eventBgColor;
              } else {
                eventBgColorTrait.set('options', fieldTextColorTraitsOptions);
              }
            }
            const eventBorderColorTrait = component.getTrait('data-event-border-color');
            if (!eventBorderColorTrait) {
              component.addTrait({
                name: 'data-event-border-color',
                label: 'Event Border Color',
                title: `Border Color`,
                options: fieldTextColorTraitsOptions,
                type: 'select',
              });
            } else {
              if (
                eventBgColor &&
                eventBgColor.includes('"') &&
                'functionType' in JSON.parse(eventBgColor)
              ) {
                // To Handle preselect trait option when JSON string in option value
                const eventBorderColorTraitSelect = eventBorderColorTrait
                  ? eventBorderColorTrait.el
                  : '';
                eventBorderColorTraitSelect.value = eventBorderColor;
              } else {
                eventBorderColorTrait.set('options', fieldTextColorTraitsOptions);
              }
            }
          }

          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
        }

        if (fieldName && collectionName) {
          selectGetContentFrom.value = `innerFields`;
          let optionHtml = `<option value="" >- Select Field -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'none';
          optionHtml += `${innerFieldOptions
            .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = fieldName;
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid) {
          selectGetContentFrom.value = `collections`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollection
            ? selectedCollection.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }
          selectExternalApiField.value = '';
        } else if (collectionName && collectionFrom === 'browserSession') {
          selectGetContentFrom.value = `browserSession`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }

          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (!sessionDataPathTrait) {
            component.addTrait(
              {
                type: 'text',
                label: 'Data Path',
                name: 'sessionDataPath',
                placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          }
          selectExternalApiField.value = '';
        } else if (collectionName && collectionFrom === 'externalAPIResponse') {
          selectGetContentFrom.value = `externalApiResponse`;
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';

          selectExternalApiFieldDiv.style.display = 'block';
          cmsExternalAPIContainer.style.display = 'block';
          cmsCreateExternalAPIContainer.style.display = 'block';

          selectField.value = collectionName;

          selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          selectExternalApiField.value = selectedCollection ? selectedCollection.externalApiId : '';
        }

        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsDataLabel.innerHTML = selectGetContentFrom.value
            ? selectGetContentFrom.value === 'collections'
              ? 'Collection'
              : 'Collection Field'
            : '';

          if (collectionName || fieldName || selectField.value || selectExternalApiField.value) {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }

            if (collectionName && finderUuid && collectionFrom !== 'externalAPIResponse') {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'block';
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'none';
            }
          } else {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepTwo');
            }
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          cmsDataLabel.innerHTML = '';
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';
          cmsCreateExternalAPIContainer.style.display = 'none';
          cmsExternalAPIContainer.style.display = 'none';
        }
      },
    });
  } else {
    traitManager.addType('data-calendar-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
